import { DefaultCatalogRecord } from "app/types/commons"
import { FC } from "react"
import { Form, FormControl, InputGroup } from "react-bootstrap-v5"
import './styles/style.css';
import { FormikProps } from "formik";

type Obligatory = {
    id: number | string,
    description: string
}[];

type Props = {
    selectOptions: DefaultCatalogRecord[] | Obligatory,
    formFormik: FormikProps<any>,
    label: string,
    htmlFor: string,
    name: string,
    styleBootstrapClasses?: string
    width?: string,
    show?: boolean,
    validation?: string | undefined,
    tabIndex?: number,
}

const InputModalSelect: FC<Props> = ({ validation, tabIndex, selectOptions, formFormik, label, htmlFor, name, styleBootstrapClasses = '', width = "50", show = true }) => {
    return (
        show ?
            <div className={`w-${width} ${styleBootstrapClasses} container__modal--input`} style={{ marginBottom: '1.5rem' }}>
                <label htmlFor={htmlFor} className="form-label">
                    {label}
                </label>

                <InputGroup>
                    <Form.Select
                        style={{ borderRadius: '5px' }}
                        id={htmlFor}
                        name={name}
                        tabIndex={tabIndex}
                        value={formFormik.values[name]}
                        onChange={(e: any) => {
                            formFormik.setFieldValue(name, e.target.value);
                        }
                        }
                        onBlur={formFormik.handleBlur}
                        required
                        isInvalid={!!(formFormik.errors[name] && formFormik.touched[name])}
                        aria-label="placeholder">
                        <option value={0}>Seleccione</option>
                        {selectOptions!.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.description}
                            </option>
                        ))}
                    </Form.Select>
                    <FormControl.Feedback type="invalid">
                        {formFormik.errors[name]}
                    </FormControl.Feedback>
                </InputGroup>
            </div>
            : null
    )
}

export { InputModalSelect }